<template>
    <vx-table-row>
        <vx-table-row-title>
            {{ props.modelValue.name }}
        </vx-table-row-title>

        <vx-table-row-item data-test="groups-count">
            <template v-slot:label> Groups: </template>
            <font-awesome-icon widthAuto
                v-if="groupCounts[props.modelValue.id] == undefined"
                :icon="faLoader"
                spin
            ></font-awesome-icon>
            <template v-else>
                {{ groupCounts[props.modelValue.id] }}
            </template>
        </vx-table-row-item>

        <vx-table-row-buttons v-if="isAdminOrOwner || isOrgUnitAdmin">
            <vx-dropdown placement="right">
                <vx-button data-test="dropdown"
                    type="button"
                    color="muted"
                    outline
                    class="w-[45px]">
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item data-test="delete"
                        @click="deleteGroupCollection()">
                        Delete
                        <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>

            <vx-button :href="props.modelValue.org_unit_id ? `/settings/teams/${props.modelValue.team_id}/org-units/${props.modelValue.org_unit_id}/group-collections/${props.modelValue.id}` : `/settings/teams/${props.modelValue.team_id}/group-collections/${props.modelValue.id}`"
                data-test="edit"
                outline
                color="muted">
                Edit <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script setup>
import {
    faEllipsis,
    faFilePen,
    faTrash,
    faLoader,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxSwal,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { useGroupCollectionsGroupsCount } from "~/composables/useGroupCollectionsGroupsCount";
import { groupCollectionsClient } from "~/services";
import { throwSwalRequestError } from "~/utils/request";
import { computed } from 'vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const isAdminOrOwner = Spark.isAdminOrOwner;

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const { groupCounts } = useGroupCollectionsGroupsCount(props.modelValue.org_unit_id);
const { roleOnCurrentOrgUnit } = useCurrentGroup();

const emit = defineEmits(['deleted']);

const isOrgUnitAdmin = computed(() => roleOnCurrentOrgUnit === 'admin');

const deleteGroupCollection = () => {
    VxSwal.confirmation(
        'Delete Group Collection',
        'Are you sure? There is no undo.',
        'danger',
        () =>
            groupCollectionsClient.deleteGroupCollection({ teamId: props.modelValue.team_id, orgUnitId: props.modelValue.org_unit_id }, props.modelValue.id)
                .then(() => emit('deleted', props.modelValue.id))
                .catch(throwSwalRequestError)
    );
};

</script>
